import posthog from "posthog-js";

const projectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

function hasAnalyticsConsent(): boolean {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    const status = window.localStorage.getItem("fnp_cookie_consent");
    if (status === "accepted") return true;
    if (status !== "custom") return false;
    const cats = JSON.parse(
      window.localStorage.getItem("fnp_cookie_categories") ?? "{}",
    ) as { analytics?: boolean; marketing?: boolean };
    // PostHog is measurement → analytics flag (marketing-only is not enough).
    return cats.analytics === true;
  } catch {
    return false;
  }
}

if (typeof window !== "undefined" && projectToken) {
  posthog.init(projectToken, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    defaults: "2026-05-30",
    capture_pageview: false,
    persistence: "localStorage",
    // Consent-first: start opted out; CookieConsentProvider opts in on accept.
    opt_out_capturing_by_default: true,
  });

  if (hasAnalyticsConsent()) {
    try {
      posthog.opt_in_capturing();
    } catch {
      /* noop */
    }
    posthog.capture("$pageview", {
      $current_url: window.location.href,
    });
  }
}
